import { render, staticRenderFns } from "./sparePartsDetail.vue?vue&type=template&id=0e0c01b0"
import script from "./sparePartsDetail.vue?vue&type=script&lang=js"
export * from "./sparePartsDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e0c01b0')) {
      api.createRecord('0e0c01b0', component.options)
    } else {
      api.reload('0e0c01b0', component.options)
    }
    module.hot.accept("./sparePartsDetail.vue?vue&type=template&id=0e0c01b0", function () {
      api.rerender('0e0c01b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/mim/inspection/sparePartsDetail.vue"
export default component.exports